<template>
  <form
    class="ecommerce-form action-buttons-fixed"
    @submit.prevent="submitForm"
  >
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-tag"></i>
                <h2 class="card-big-info-title">
                  {{ translations.metaSeoDetails }}
                </h2>
                <p class="card-big-info-desc">
                  {{ translations.metaSeo }}
                </p>
              </div>

              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center mb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Naslov</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Naziv"
                      v-model="metaSeo.title"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center mb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Opis</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <textarea
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Opis"
                      v-model="metaSeo.description"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center mb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Keyword</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Keyword"
                      v-model="metaSeo.keyword"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="row action-buttons">
      <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
        <button
          type="submit"
          class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
        >
          <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { translations } from '@/mixins';
import helpers from '@/services/helpers';
import api from '@/services/api';

export default {
  name: 'MetaSeoBrands',
  mixins: [translations],
  data() {
    return {
      pageType: helpers.PageTypes.Brands,
    };
  },
  computed: {
    metaSeo() {
      return this.$store.getters.getMetaSeo;
    },
  },
  methods: {
    submitForm() {
      const { metaSeo, pageType } = this;

      api
        .updateMetaSeo(pageType, metaSeo)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getMetaSeo', this.pageType);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
  },
  mounted() {
    this.$store.dispatch('getMetaSeo', this.pageType);
  },
};
</script>
